module.exports = __webpack_public_path__ + "static/img/image_solutions_key_panda.8bdd31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_key_panda.png
// module id = nahR
// module chunks = 10